// import React, { useState } from "react";
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import apiConfig from "../../config/apiConfig";
// import {
//   AllCommunityModule,
//   ModuleRegistry,
//   themeAlpine,
//   themeBalham,
// } from "ag-grid-community";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from "@tanstack/react-query";

// ModuleRegistry.registerModules([AllCommunityModule]);

// interface ColumnDef {
//   field: string;
//   headerName: string;
//   editable: boolean;
//   resizable: boolean;
//   sortable: boolean;
//   filter: boolean;
//   cellRenderer?: (params: any) => React.ReactNode;
// }

// // Define the custom cell renderer for the action column
// const ActionCellRenderer = (props: any) => {
//   const handleEdit = () => {
//     props.context.handleUpdate(props.data.id);
//   };

//   return (
//     <button onClick={handleEdit} className="btn btn-primary">
//       Edit
//     </button>
//   );
// };

// export type ResourceMetaData = {
//   resource: string;
//   fieldValues: any[];
// };
// const getCookie = (name: string): string | null => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//   return null;
// };

// const UpdateProgram = () => {
//   const [rowData, setRowData] = useState<any[]>([]);
//   const [colDef1, setColDef1] = useState<any[]>([]);
//   const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
//   const [fields, setFields] = useState<any[]>([]);
//   const [requiredFields, setRequiredFields] = useState<string[]>([]);
//   const [fetchData, setFetchedData] = useState<any[]>([]);
//   const [editedData, setEditedData] = useState<any>({});
//   const [showToast, setShowToast] = useState<any>(false);
//   const navigate = useNavigate();
//   const apiUrl = `${apiConfig.getResourceUrl("program")}?`;
//   const metadataUrl = `${apiConfig.getResourceMetaDataUrl("Program")}?`;
//   const BaseUrl = `${apiConfig.API_BASE_URL}`;
//   const regex = /^(g_|archived|extra_data)/;

//   const [currentUrl, setCurrentUrl] = useState("");
//   // Fetch resource data
//   const {
//     data: dataRes,
//     isLoading: isLoadingDataRes,
//     error: errorDataRes,
//   } = useQuery({
//     queryKey: ["resourceData", "programUpdate"],
//     queryFn: async () => {
//       const params = new URLSearchParams();

//       const queryId: any = "GET_ALL";
//       params.append("queryId", queryId);
//       const accessToken = getCookie("access_token");

//       if (!accessToken) {
//         throw new Error("Access token not found");
//       }

//       const response = await fetch(
//         `${apiConfig.getResourceUrl("program")}?` + params.toString(),
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`, // Add token here
//           },
//           credentials: "include", // include cookies if needed
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();
//       setFetchedData(data.resource || []);
//       const initialEditedData = fetchData.reduce((acc: any, item: any) => {
//         acc[item.id] = { ...item };
//         return acc;
//       }, {});
//       return data;
//     },
//   });

//   // Fetch metadata
//   const {
//     data: dataResMeta,
//     isLoading: isLoadingDataResMeta,
//     error: errorDataResMeta,
//   } = useQuery({
//     queryKey: ["resourceMetaData", "programUpdate"],
//     queryFn: async () => {
//       const response = await fetch(
//         `${apiConfig.getResourceMetaDataUrl("program")}?`,
//         {
//           method: "GET",
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();
//       setResMetaData(data);
//       setFields(data[0]?.fieldValues || []);
//       const required = data[0]?.fieldValues
//         .filter((field: any) => !regex.test(field.name))
//         .map((field: any) => field.name);
//       setRequiredFields(required || []);
//       return data;
//     },
//   });

//   const handleEdit = (id: any, field: string, value: string) => {
//     setEditedData((prevData: any) => ({
//       ...prevData,
//       [id]: {
//         ...(prevData[id] || {}),
//         [field]: value,
//       },
//     }));
//   };

//   const handleUpdate = async (id: any) => {
//     navigate(`/edit/program/${id}`);
//   };

//   useEffect(() => {
//     const data = fetchData || [];
//     const fields = requiredFields.filter((field) => field !== "id") || [];

//     const columns = fields.map((field) => ({
//       field: field,
//       headerName: field,
//       editable: false,
//       resizable: true,
//       sortable: true,
//       filter: true,
//     }));

//     // Add the Action column with the custom cell renderer
//     columns.push({
//       headerName: "Action",
//       field: "Action",
//       cellRenderer: ActionCellRenderer,
//       editable: false,
//       resizable: true,
//       sortable: false,
//       filter: false,
//       width: 120,
//     } as ColumnDef);
//     setColDef1(columns);
//     setRowData(data);
//   }, [fetchData, requiredFields]);

//   const defaultColDef = {
//     flex: 1,
//     minWidth: 100,
//     editable: false,
//   };

//   return (
//     <div>
//       <div className="">
//         {rowData.length === 0 && colDef1.length === 0 ? (
//           <div>No data available. Please add a resource attribute.</div>
//         ) : (
//           <div
//             className="ag-theme-alpine"
//             style={{ height: 500, width: "100%" }}
//           >
//             <AgGridReact
//               rowData={rowData}
//               columnDefs={colDef1}
//               defaultColDef={defaultColDef}
//               pagination={true}
//               paginationPageSize={10}
//               animateRows={true}
//               rowSelection="multiple"
//               context={{
//                 handleUpdate: handleUpdate,
//               }}
//             />
//           </div>
//         )}
//       </div>

//       {showToast && (
//         <div
//           className="toast-container position-fixed top-20 start-50 translate-middle p-3"
//           style={{ zIndex: 1550 }}
//         >
//           <div
//             className="toast show"
//             role="alert"
//             aria-live="assertive"
//             aria-atomic="true"
//           >
//             <div className="toast-header">
//               <strong className="me-auto">Success</strong>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="toast"
//                 aria-label="Close"
//                 onClick={() => setShowToast(false)}
//               ></button>
//             </div>
//             <div className="toast-body text-success text-center">
//               Created successfully!
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UpdateProgram;

// import React, { useMemo, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import apiConfig from "../../config/apiConfig";

// import { AllCommunityModule, ModuleRegistry, ColDef } from "ag-grid-community";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from "@tanstack/react-query";

// ModuleRegistry.registerModules([AllCommunityModule]);

// // -------------------- COOKIE --------------------
// const getCookie = (name: string): string | null => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//   return null;
// };

// // -------------------- FORMAT HEADER --------------------
// const formatHeaderName = (field: string) =>
//   field
//     .replace(/_/g, " ")
//     .replace(/\b\w/g, (c) => c.toUpperCase());

// // -------------------- ACTION RENDERER --------------------
// const ActionCellRenderer = (props: any) => {
//   const handleEdit = () => props.context.handleUpdate(props.data.id);

//   return (
//     <button
//       className="btn btn-outline-primary"
//       style={{
//         fontSize: "13px",
//         padding: "6px 14px",
//         borderRadius: "8px",
//         fontWeight: 600,
//       }}
//       onClick={handleEdit}
//     >
//       Edit
//     </button>
//   );
// };

// const UpdateProgram = () => {
//   const navigate = useNavigate();
//   const gridRef = useRef<AgGridReact>(null);

//   const [rowData, setRowData] = useState<any[]>([]);
//   const regex = /^(g_|archived|extra_data)/;

//   // ---------------- FETCH METADATA ----------------
//   const { data: metaData } = useQuery({
//     queryKey: ["programMetaData"],
//     queryFn: async () => {
//       const res = await fetch(
//         apiConfig.getResourceMetaDataUrl("program")
//       );
//       if (!res.ok) throw new Error("Metadata load failed");
//       return res.json();
//     },
//   });

//   // ---------------- FETCH PROGRAM DATA ----------------
//   useQuery({
//     queryKey: ["programData"],
//     queryFn: async () => {
//       const params = new URLSearchParams({ queryId: "GET_ALL" });
//       const token = getCookie("access_token");

//       const res = await fetch(
//         `${apiConfig.getResourceUrl("program")}?${params.toString()}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!res.ok) throw new Error("Program load failed");

//       const json = await res.json();
//       setRowData(json.resource || []);
//       return json.resource;
//     },
//   });

//   const handleUpdate = (id: any) => navigate(`/edit/program/${id}`);

//   // ============================================================
//   //            COLUMN DEFINITIONS (REFERENCE STYLE)
//   // ============================================================
//   const colDefs = useMemo<ColDef[]>(() => {
//     if (!metaData?.[0]?.fieldValues) return [];

//     const fields = metaData[0].fieldValues
//       .filter((f: any) => !regex.test(f.name))
//       .map((f: any) => f.name)
//       .filter((f: string) => f !== "id");

//     const dynamicCols: ColDef[] = fields.map((field:any) => ({
//       headerName: formatHeaderName(field),
//       field,
//       sortable: true,
//       filter: true,
//     }));

//     return [
//       ...dynamicCols,
//       {
//         headerName: "Action",
//         field: "action",
//         cellRenderer: ActionCellRenderer,
//         sortable: false,
//         filter: false,
//         width: 120,
//       },
//     ];
//   }, [metaData]);

//   const defaultColDef: ColDef = {
//     flex: 1,
//     minWidth: 120,
//     resizable: true,
//     editable: false,
//     cellStyle: { display: "flex", alignItems: "center" },
//   };

//   return (
//     <>
//       <div className="ag-theme-alpine" style={{ height: 500 }}>
//         <AgGridReact
//           ref={gridRef}
//           rowData={rowData}
//           columnDefs={colDefs}
//           defaultColDef={defaultColDef}
//           pagination
//           paginationPageSize={10}
//           animateRows
//           context={{ handleUpdate }}
//         />
//       </div>
//     </>
//   );
// };

// export default UpdateProgram;

// import React, { useState } from 'react';
// import { useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import apiConfig from '../../config/apiConfig';
// import {
//   AllCommunityModule,
//   ModuleRegistry,
//   themeAlpine,
//   themeBalham
// } from "ag-grid-community";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from '@tanstack/react-query';

// ModuleRegistry.registerModules([AllCommunityModule]);

// interface ColumnDef {
//   field: string;
//   headerName: string;
//   editable: boolean;
//   resizable: boolean;
//   sortable: boolean;
//   filter: boolean;
//   cellRenderer?: (params: any) => React.ReactNode;
// }

// // Define the custom cell renderer for the action column
// const ActionCellRenderer = (props:any) => {
//   const handleEdit = () => {
//     props.context.handleUpdate(props.data.id);
//   };

//   return (
//     <button onClick={handleEdit} className="btn btn-primary">
//       Edit
//     </button>
//   );
// };

// export type ResourceMetaData = {
//   "resource": string,
//   "fieldValues": any[]
// }
// const getCookie = (name: string): string | null => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//     return null;
//   };

//   const UpdateProgram = () => {
//    const [rowData, setRowData] = useState<any[]>([]);
//   const [colDef1, setColDef1] = useState<any[]>([]);
//   const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
//   const [fields, setFields] = useState<any[]>([]);
//   const [requiredFields, setRequiredFields] = useState<string[]>([]);
//   const [fetchData, setFetchedData] = useState<any[]>([]);
//   const [editedData, setEditedData] = useState<any>({});
//   const [showToast, setShowToast] = useState<any>(false);
//   const navigate = useNavigate();
//   const apiUrl = `${apiConfig.getResourceUrl('program')}?`
//   const metadataUrl = `${apiConfig.getResourceMetaDataUrl('Program')}?`
//   const BaseUrl = `${apiConfig.API_BASE_URL}`;
//   const regex = /^(g_|archived|extra_data)/;

//    const [currentUrl, setCurrentUrl] = useState('');
//     // Fetch resource data
//     const {data:dataRes,isLoading:isLoadingDataRes,error:errorDataRes}= useQuery({
//     queryKey: ['resourceData', 'programUpdate'],
//      queryFn: async () => {
//       const params = new URLSearchParams();

//       const queryId: any = "GET_ALL";
//       params.append("queryId", queryId);
//        const accessToken = getCookie("access_token");

//   if (!accessToken) {
//     throw new Error("Access token not found");
//   }

//       const response = await fetch(
//         `${apiConfig.getResourceUrl('program')}?` + params.toString(),
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${accessToken}`, // Add token here
//           },
//           credentials: "include", // include cookies if needed
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();
//       setFetchedData(data.resource || []);
//        const initialEditedData = fetchData.reduce((acc: any, item: any) => {
//             acc[item.id] = { ...item };
//             return acc;
//              }, {});
//       return data;
//     },
//   })

//     // Fetch metadata
//     const {data: dataResMeta,isLoading:isLoadingDataResMeta,error:errorDataResMeta} = useQuery({
//     queryKey: ['resourceMetaData', 'programUpdate'],
//    queryFn: async () => {
//       const response = await fetch(
//         `${apiConfig.getResourceMetaDataUrl('program')}?`,
//         {
//           method: "GET",
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Error: " + response.status);
//       }

//       const data = await response.json();
//       setResMetaData(data);
//       setFields(data[0]?.fieldValues || []);
//       const required = data[0]?.fieldValues
//         .filter((field: any) => !regex.test(field.name))
//         .map((field: any) => field.name);
//       setRequiredFields(required || []);
//       return data;
//     },
//   });

//     const handleEdit = (id: any, field: string, value: any) => {
//       setEditedData((prevData: any) => ({
//         ...prevData,
//         [id]: {
//           ...(prevData[id] || {}),
//           [field]: value,
//         },
//       }));
//     };

//     const handleUpdate = async (id: any) => {

//     navigate(`/edit/program/${id}`);
// };

//   useEffect(() => {
//     const data = fetchData || [];
//     const fields = requiredFields.filter(field => field !== 'id') || [];

//     const columns = fields.map(field => ({
//       field: field,
//       headerName: field,
//       editable: false,
//       resizable: true,
//       sortable: true,
//       filter: true
//     }));

//     // Add the Action column with the custom cell renderer
//     columns.push({
//       headerName: 'Action',
//       field: 'Action',
//       cellRenderer: ActionCellRenderer,
//       editable: false,
//       resizable: true,
//       sortable: false,
//       filter: false,
//       width: 120
//     } as ColumnDef)
//     setColDef1(columns);
//     setRowData(data);
//   }, [fetchData, requiredFields]);

//   const defaultColDef = {
//     flex: 1,
//     minWidth: 100,
//     editable: false,
//   };

// return (
//     <div>

// <div className="">
//     {rowData.length === 0 && colDef1.length === 0 ? (
//       <div>No data available. Please add a resource attribute.</div>
//     ) : (
//       <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
//         <AgGridReact
//           rowData={rowData}
//           columnDefs={colDef1}
//           defaultColDef={defaultColDef}
//           pagination={true}
//           paginationPageSize={10}
//           animateRows={true}
//           rowSelection="multiple"
//           context={{
//             handleUpdate: handleUpdate
//           }}
//         />
//       </div>
//     )}
//   </div>

//   {showToast && (
//     <div
//       className="toast-container position-fixed top-20 start-50 translate-middle p-3"
//       style={{ zIndex: 1550 }}
//     >
//       <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
//         <div className="toast-header">
//           <strong className="me-auto">Success</strong>
//           <button
//             type="button"
//             className="btn-close"
//             data-bs-dismiss="toast"
//             aria-label="Close"
//             onClick={() => setShowToast(false)}
//           ></button>
//         </div>
//         <div className="toast-body text-success text-center">Created successfully!</div>
//       </div>
//     </div>
// ) }

// </div>
// )

// };

// export default UpdateProgram

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import apiConfig from "../../config/apiConfig";

// import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from "@tanstack/react-query";

// ModuleRegistry.registerModules([AllCommunityModule]);

// interface ColumnDef {
//   field: string;
//   headerName: string;
//   editable: boolean;
//   resizable: boolean;
//   sortable: boolean;
//   filter: boolean;
//   cellRenderer?: (params: any) => React.ReactNode;
// }

// // ---------------- ACTION CELL (UI ONLY CHANGE) ----------------
// const ActionCellRenderer = (props: any) => {
//   const handleEdit = () => {
//     props.context.handleUpdate(props.data.id);
//   };

//   return (
//     <button
//       onClick={handleEdit}
//       className="btn btn-outline-primary"
//       style={{
//         fontSize: "13px",
//         padding: "6px 14px",
//         borderRadius: "8px",
//         fontWeight: 600,
//       }}
//     >
//       Edit
//     </button>
//   );
// };

// export type ResourceMetaData = {
//   resource: string;
//   fieldValues: any[];
// };

// const getCookie = (name: string): string | null => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//   return null;
// };

// const UpdateProgram = () => {
//   const [rowData, setRowData] = useState<any[]>([]);
//   const [colDef1, setColDef1] = useState<any[]>([]);
//   const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
//   const [fields, setFields] = useState<any[]>([]);
//   const [requiredFields, setRequiredFields] = useState<string[]>([]);
//   const [fetchData, setFetchedData] = useState<any[]>([]);
//   const [editedData, setEditedData] = useState<any>({});
//   const [showToast, setShowToast] = useState<any>(false);

//   const navigate = useNavigate();
//   const regex = /^(g_|archived|extra_data)/;

//   // ---------------- FETCH PROGRAM DATA ----------------
//   useQuery({
//     queryKey: ["resourceData", "programUpdate"],
//     queryFn: async () => {
//       const params = new URLSearchParams();
//       params.append("queryId", "GET_ALL");

//       const accessToken = getCookie("access_token");
//       if (!accessToken) throw new Error("Access token not found");

//       const response = await fetch(
//         `${apiConfig.getResourceUrl("program")}?${params.toString()}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           credentials: "include",
//         }
//       );

//       if (!response.ok) throw new Error("Error: " + response.status);

//       const data = await response.json();
//       setFetchedData(data.resource || []);
//       return data.resource;
//     },
//   });

//   // ---------------- FETCH METADATA ----------------
//   useQuery({
//     queryKey: ["resourceMetaData", "programUpdate"],
//     queryFn: async () => {
//       const response = await fetch(apiConfig.getResourceMetaDataUrl("program"));

//       if (!response.ok) throw new Error("Error: " + response.status);

//       const data = await response.json();
//       setResMetaData(data);
//       setFields(data[0]?.fieldValues || []);

//       const required = data[0]?.fieldValues
//         .filter((field: any) => !regex.test(field.name))
//         .map((field: any) => field.name);

//       setRequiredFields(required || []);
//       return data;
//     },
//   });

//   const handleUpdate = (id: any) => {
//     navigate(`/edit/program/${id}`);
//   };

//   // ---------------- BUILD GRID COLUMNS ----------------
//   useEffect(() => {
//     const data = fetchData || [];
//     const visibleFields =
//       requiredFields.filter((field) => field !== "id") || [];

//     const columns = visibleFields.map((field) => ({
//       field,
//       headerName: field
//         .replace(/_/g, " ")
//         .replace(/\b\w/g, (c) => c.toUpperCase()),
//       editable: false,
//       resizable: true,
//       sortable: true,
//       filter: true,
//     }));

//     columns.push({
//       headerName: "Action",
//       field: "Action",
//       cellRenderer: ActionCellRenderer,
//       editable: false,
//       resizable: true,
//       sortable: false,
//       filter: false,
//       width: 120,
//     } as ColumnDef);

//     setColDef1(columns);
//     setRowData(data);
//   }, [fetchData, requiredFields]);

//   const defaultColDef = {
//     flex: 1,
//     minWidth: 120,
//     editable: false,
//     resizable: true,
//   };

//   // ---------------- UI ONLY UPDATED ----------------
//   return (
//     <div style={{ padding: "16px" }}>
//       {rowData.length === 0 && colDef1.length === 0 ? (
//         <div>No data available. Please add a resource attribute.</div>
//       ) : (
//         <div
//           className="ag-theme-alpine"
//           style={{
//             height: 500,
//             width: "100%",
//             borderRadius: "10px",
//             overflow: "hidden",
//           }}
//         >
//           <AgGridReact
//             rowData={rowData}
//             columnDefs={colDef1}
//             defaultColDef={defaultColDef}
//             pagination
//             paginationPageSize={10}
//             animateRows
//             rowSelection="multiple"
//             context={{ handleUpdate }}
//           />
//         </div>
//       )}

//       {showToast && (
//         <div
//           className="toast-container position-fixed top-20 start-50 translate-middle p-3"
//           style={{ zIndex: 1550 }}
//         >
//           <div className="toast show" role="alert">
//             <div className="toast-header">
//               <strong className="me-auto">Success</strong>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={() => setShowToast(false)}
//               />
//             </div>
//             <div className="toast-body text-success text-center">
//               Created successfully!
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UpdateProgram;
// import React, { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import apiConfig from "../../config/apiConfig";

// import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
// import { AgGridReact } from "ag-grid-react";
// import { useQuery } from "@tanstack/react-query";

// ModuleRegistry.registerModules([AllCommunityModule]);

// interface ColumnDef {
//   field: string;
//   headerName: string;
//   editable: boolean;
//   resizable: boolean;
//   sortable: boolean;
//   filter: boolean;
//   cellRenderer?: (params: any) => React.ReactNode;
//   width?: number;
//   valueGetter?: (params: any) => any;
//   valueFormatter?: (params: any) => any;
// }

// // ---------------- ACTION CELL ----------------
// const ActionCellRenderer = (props: any) => {
//   const handleEdit = () => props.context.handleUpdate(props.data.id);

//   return (
//     <button
//       onClick={handleEdit}
//       className="btn btn-outline-primary"
//       style={{
//         fontSize: "13px",
//         padding: "6px 14px",
//         borderRadius: "8px",
//         fontWeight: 600,
//       }}
//     >
//       Edit
//     </button>
//   );
// };

// export type ResourceMetaData = {
//   resource: string;
//   fieldValues: any[];
// };

// const getCookie = (name: string): string | null => {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
//   return null;
// };

// // ✅ helper: label for academic year (as per your Java model -> academic_name)
// const getAcademicYearLabel = (ay: any) =>
//   ay?.academic_name || ay?.academicName || ay?.name || ay?.id || "";

// const getCourseStatus = (
//   courseStart?: string,
//   courseEnd?: string
// ): "UPCOMING" | "ONGOING" | "COMPLETED" | "" => {
//   if (!courseStart || !courseEnd) return "";

//   const today = new Date().setHours(0, 0, 0, 0);
//   const start = new Date(courseStart).setHours(0, 0, 0, 0);
//   const end = new Date(courseEnd).setHours(0, 0, 0, 0);

//   if (today < start) return "UPCOMING";
//   if (today > end) return "COMPLETED";
//   return "ONGOING";
// };

// const UpdateProgram = () => {
//   const [rowData, setRowData] = useState<any[]>([]);
//   const [colDef1, setColDef1] = useState<any[]>([]);
//   const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
//   const [fields, setFields] = useState<any[]>([]);
//   const [requiredFields, setRequiredFields] = useState<string[]>([]);
//   const [fetchData, setFetchedData] = useState<any[]>([]);
//   const [showToast, setShowToast] = useState<any>(false);

//   const navigate = useNavigate();
//   const regex = /^(g_|archived|extra_data)/;

//   // ---------------- FETCH PROGRAM DATA ----------------
//   useQuery({
//     queryKey: ["resourceData", "programUpdate"],
//     queryFn: async () => {
//       const params = new URLSearchParams();
//       params.append("queryId", "GET_ALL");

//       const accessToken = getCookie("access_token");
//       if (!accessToken) throw new Error("Access token not found");

//       const response = await fetch(
//         `${apiConfig.getResourceUrl("program")}?${params.toString()}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           credentials: "include",
//         }
//       );

//       if (!response.ok) throw new Error("Error: " + response.status);

//       const data = await response.json();
//       setFetchedData(data.resource || []);
//       return data.resource || [];
//     },
//   });

//   // ---------------- FETCH ACADEMIC YEAR DATA (for id -> name mapping) ----------------
//   const { data: academicYearRows } = useQuery({
//     queryKey: ["resourceData", "academicYearLookup"],
//     queryFn: async () => {
//       const params = new URLSearchParams();
//       params.append("queryId", "GET_ALL");

//       const accessToken = getCookie("access_token");
//       if (!accessToken) throw new Error("Access token not found");

//       // resource name in your Java class: "academic_year"
//       const response = await fetch(
//         `${apiConfig.getResourceUrl("academic_year")}?${params.toString()}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           credentials: "include",
//         }
//       );

//       if (!response.ok) throw new Error("Error: " + response.status);

//       const data = await response.json();
//       return data.resource || [];
//     },
//   });

//   // ✅ Build map: academic_year_id -> academic_name
//   const academicYearMap = useMemo(() => {
//     const map: Record<string, string> = {};
//     (academicYearRows || []).forEach((ay: any) => {
//       if (ay?.id) map[ay.id] = getAcademicYearLabel(ay);
//     });
//     return map;
//   }, [academicYearRows]);

//   // ---------------- FETCH METADATA ----------------
//   useQuery({
//     queryKey: ["resourceMetaData", "programUpdate"],
//     queryFn: async () => {
//       const response = await fetch(apiConfig.getResourceMetaDataUrl("program"));
//       if (!response.ok) throw new Error("Error: " + response.status);

//       const data = await response.json();
//       setResMetaData(data);
//       setFields(data[0]?.fieldValues || []);

//       const required = data[0]?.fieldValues
//         .filter((field: any) => !regex.test(field.name))
//         .map((field: any) => field.name);

//       setRequiredFields(required || []);
//       return data;
//     },
//   });

//   const handleUpdate = (id: any) => {
//     navigate(`/edit/program/${id}`);
//   };

//   // ---------------- BUILD GRID COLUMNS ----------------
//   useEffect(() => {
//     const data = fetchData || [];
//     const visibleFields = requiredFields.filter((field) => field !== "id") || [];

//     const columns: any[] = visibleFields.map((field) => {
//       // ✅ Replace Academic Year Id column values with name
//       if (field === "academic_year_id") {
//         return {
//           field,
//           headerName: "Academic Year",
//           editable: false,
//           resizable: true,
//           sortable: true,
//           filter: true,
//           // valueGetter affects rendering + filter + sort
//           valueGetter: (params: any) => {
//             const id = params?.data?.academic_year_id;
//             return academicYearMap[id] || id || "";
//           },
//         };
//       }

//       return {
//         field,
//         headerName: field
//           .replace(/_/g, " ")
//           .replace(/\b\w/g, (c) => c.toUpperCase()),
//         editable: false,
//         resizable: true,
//         sortable: true,
//         filter: true,
//       };
//     });

//     columns.push({
//   field: "status",
//   headerName: "Status",
//   editable: false,
//   resizable: true,
//   sortable: true,
//   filter: true,

//   valueGetter: (params: any) => {
//     const start = params?.data?.course_start_date;
//     const end = params?.data?.course_end_date;
//     return getCourseStatus(start, end);
//   },

//   cellRenderer: (params: any) => {
//     const status = params.value;

//     let color = "#0d6efd";
//     if (status === "ONGOING") color = "green";
//     else if (status === "COMPLETED") color = "red";

//     return (
//       <span style={{ fontWeight: 600, color }}>
//         {status}
//       </span>
//     );
//   },

//   width: 130,
// });


//     columns.push({
//       headerName: "Action",
//       field: "Action",
//       cellRenderer: ActionCellRenderer,
//       editable: false,
//       resizable: true,
//       sortable: false,
//       filter: false,
//       width: 120,
//     } as ColumnDef);

//     setColDef1(columns);
//     setRowData(data);
//   }, [fetchData, requiredFields, academicYearMap]);

//   const defaultColDef = {
//     flex: 1,
//     minWidth: 120,
//     editable: false,
//     resizable: true,
//   };

  

//   // ---------------- UI ----------------
//   return (
//     <div style={{ padding: "16px" }}>
//       {rowData.length === 0 && colDef1.length === 0 ? (
//         <div>No data available. Please add a resource attribute.</div>
//       ) : (
//         <div
//           className="ag-theme-alpine"
//           style={{
//             height: 500,
//             width: "100%",
//             borderRadius: "10px",
//             overflow: "hidden",
//           }}
//         >
//           <AgGridReact
//             rowData={rowData}
//             columnDefs={colDef1}
//             defaultColDef={defaultColDef}
//             pagination
//             paginationPageSize={10}
//             animateRows
//             rowSelection="multiple"
//             context={{ handleUpdate }}
//           />
//         </div>
//       )}

//       {showToast && (
//         <div
//           className="toast-container position-fixed top-20 start-50 translate-middle p-3"
//           style={{ zIndex: 1550 }}
//         >
//           <div className="toast show" role="alert">
//             <div className="toast-header">
//               <strong className="me-auto">Success</strong>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={() => setShowToast(false)}
//               />
//             </div>
//             <div className="toast-body text-success text-center">
//               Created successfully!
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UpdateProgram;


import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import apiConfig from "../../config/apiConfig";

import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Download } from "lucide-react";
import * as XLSX from "xlsx";

ModuleRegistry.registerModules([AllCommunityModule]);

interface ColumnDef {
  field: string;
  headerName: string;
  editable: boolean;
  resizable: boolean;
  sortable: boolean;
  filter: boolean;
  cellRenderer?: (params: any) => React.ReactNode;
  width?: number;
  valueGetter?: (params: any) => any;
  valueFormatter?: (params: any) => any;
}

// ---------------- ACTION CELL ----------------
const ActionCellRenderer = (props: any) => {
  const handleEdit = () => props.context.handleUpdate(props.data.id);
  const handleDelete = () => props.context.handleDelete(props.data.id);

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <button
        onClick={handleEdit}
        className="btn btn-outline-primary"
        style={{
          fontSize: "13px",
          padding: "6px 14px",
          borderRadius: "8px",
          fontWeight: 600,
        }}
      >
        Edit
      </button>
      <button
        onClick={handleDelete}
        className="btn btn-outline-danger"
        style={{
          fontSize: "13px",
          padding: "6px 14px",
          borderRadius: "8px",
          fontWeight: 600,
        }}
      >
        Delete
      </button>
    </div>
  );
};

export type ResourceMetaData = {
  resource: string;
  fieldValues: any[];
};

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

// ✅ helper: label for academic year
const getAcademicYearLabel = (ay: any) =>
  ay?.academic_name || ay?.academicName || ay?.name || ay?.id || "";

// ✅ SAME STATUS LOGIC (UNCHANGED)
const getCourseStatus = (
  courseStart?: string,
  courseEnd?: string
): "UPCOMING" | "ONGOING" | "COMPLETED" | "" => {
  if (!courseStart || !courseEnd) return "";

  const today = new Date().setHours(0, 0, 0, 0);
  const start = new Date(courseStart).setHours(0, 0, 0, 0);
  const end = new Date(courseEnd).setHours(0, 0, 0, 0);

  if (today < start) return "UPCOMING";
  if (today > end) return "COMPLETED";
  return "ONGOING";
};

// ✅ Date Formatter helper
const formatDateStr = (value: any) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  // formats to DD MMM YYYY (eg 01 Apr 2024)
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const UpdateProgram = () => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<any[]>([]);
  const [colDef1, setColDef1] = useState<any[]>([]);
  const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
  const [fields, setFields] = useState<any[]>([]);
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [fetchData, setFetchedData] = useState<any[]>([]);
  const [showToast, setShowToast] = useState<any>(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const regex = /^(g_|archived|extra_data)/;

  // ---------------- FETCH PROGRAM DATA ----------------
  useQuery({
    queryKey: ["resourceData", "programUpdate"],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("queryId", "GET_ALL");

      const accessToken = getCookie("access_token");
      if (!accessToken) throw new Error("Access token not found");

      const response = await fetch(
        `${apiConfig.getResourceUrl("program")}?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: "include",
        }
      );

      if (!response.ok) throw new Error("Error: " + response.status);

      const data = await response.json();
      setFetchedData(data.resource || []);
      return data.resource || [];
    },
  });

  // ---------------- FETCH ACADEMIC YEAR ----------------
  const { data: academicYearRows } = useQuery({
    queryKey: ["resourceData", "academicYearLookup"],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("queryId", "GET_ALL");

      const accessToken = getCookie("access_token");
      if (!accessToken) throw new Error("Access token not found");

      const response = await fetch(
        `${apiConfig.getResourceUrl("academic_year")}?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: "include",
        }
      );

      if (!response.ok) throw new Error("Error: " + response.status);

      const data = await response.json();
      return data.resource || [];
    },
  });

  const academicYearMap = useMemo(() => {
    const map: Record<string, string> = {};
    (academicYearRows || []).forEach((ay: any) => {
      if (ay?.id) map[ay.id] = getAcademicYearLabel(ay);
    });
    return map;
  }, [academicYearRows]);

  // ---------------- FETCH REGISTRATION DATA FOR SEAT COUNTS ----------------
  const { data: regRows } = useQuery({
    queryKey: ["resourceData", "programRegistrationLookup"],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("queryId", "GET_ALL");

      const accessToken = getCookie("access_token");
      if (!accessToken) throw new Error("Access token not found");

      const response = await fetch(
        `${apiConfig.getResourceUrl("program_registration")}?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: "include",
        }
      );

      if (!response.ok) return [];

      const data = await response.json();
      return data.resource || [];
    },
    refetchInterval: 5000,
  });

  const seatCountsMap = useMemo(() => {
    const filledMap = new Map<string, number>();
    (regRows || []).forEach((r: any) => {
      if (r?.program_id) {
        filledMap.set(String(r.program_id), (filledMap.get(String(r.program_id)) || 0) + 1);
      }
    });
    return filledMap;
  }, [regRows]);

  // ---------------- FETCH METADATA ----------------
  useQuery({
    queryKey: ["resourceMetaData", "programUpdate"],
    queryFn: async () => {
      const response = await fetch(apiConfig.getResourceMetaDataUrl("program"));
      if (!response.ok) throw new Error("Error: " + response.status);

      const data = await response.json();
      setResMetaData(data);
      setFields(data[0]?.fieldValues || []);

      const required = data[0]?.fieldValues
        .filter((field: any) => !regex.test(field.name))
        .map((field: any) => field.name);

      setRequiredFields(required || []);
      return data;
    },
  });

  const handleUpdate = (id: any) => {
    navigate(`/edit/program/${id}`);
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this program?")) return;

    const payload = { id };
    const formData = new FormData();
    const base64 = btoa(JSON.stringify(payload));

    formData.append("resource", base64);
    formData.append("action", "DELETE");
    formData.append("dmsRole", "admin");
    formData.append("user_id", "admin@rasp.com");

    const accessToken = getCookie("access_token");
    if (!accessToken) {
      alert("Access token missing!");
      return;
    }

    try {
      const response = await fetch(apiConfig.getResourceUrl("program"), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Delete failed");

      await queryClient.invalidateQueries({
        queryKey: ["resourceData", "programUpdate"],
      });
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete program. Please try again.");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleViewPdf = async (documentId: string) => {
    if (!documentId) return;
    try {
      const url =
        `${apiConfig.getResourceUrl("program")}?` +
        `document_id=${documentId}&queryId=GET_DOCUMENT` +
        `&dmsRole=admin&user_id=admin@rasp.com`;

      const token = getCookie("access_token");
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      });

      if (!res.ok) {
        alert("Failed to load document");
        return;
      }

      const blob = await res.blob();
      const fileURL = URL.createObjectURL(blob);
      setPdfUrl(fileURL);
      setShowModal(true);
    } catch (e) {
      console.error(e);
      alert("Error loading syllabus document.");
    }
  };

  // ---------------- EXPORT TO EXCEL ----------------
  const handleExportExcel = () => {
    const api = gridRef.current?.api;
    let exportRows: any[] = [];

    if (api) {
      api.forEachNodeAfterFilterAndSort((node) => {
        if (node.data) exportRows.push(node.data);
      });
    }

    if (exportRows.length === 0 && rowData && rowData.length > 0) {
      exportRows = rowData;
    }

    if (!exportRows || exportRows.length === 0) {
      alert("No course data available to export.");
      return;
    }

    const dataToExport = exportRows.map((row, index) => {
      const seats = Number(row.seats ?? 0);
      const filledSeats = seatCountsMap.get(String(row.id)) || 0;
      const availableSeats = Math.max(0, seats - filledSeats);
      const ayName =
        academicYearMap[row.academic_year_id] ||
        row.academic_year_id ||
        "-";
      const status = getCourseStatus(
        row.course_start_date,
        row.course_end_date
      );

      return {
        "S.No": index + 1,
        "Name": row.name || "-",
        "Seats": seats,
        "Filled Seats": filledSeats,
        "Available Seats": availableSeats <= 0 ? "FULL" : `${availableSeats}/${seats}`,
        "Instructor Name": row.instructor_name || "-",
        "Term Name": row.term_name || "-",
        "Academic Year": ayName,
        "Registration Start Date": formatDateStr(row.registration_start_date),
        "Registration End Date": formatDateStr(row.registration_end_date),
        "Course Start Date": formatDateStr(row.course_start_date),
        "Course End Date": formatDateStr(row.course_end_date),
        "Status": status || "-",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);

    // Auto-fit column widths
    worksheet["!cols"] = [
      { wch: 8 },  // S.No
      { wch: 25 }, // Name
      { wch: 10 }, // Seats
      { wch: 14 }, // Filled Seats
      { wch: 16 }, // Available Seats
      { wch: 22 }, // Instructor Name
      { wch: 14 }, // Term Name
      { wch: 18 }, // Academic Year
      { wch: 24 }, // Registration Start Date
      { wch: 24 }, // Registration End Date
      { wch: 20 }, // Course Start Date
      { wch: 20 }, // Course End Date
      { wch: 15 }, // Status
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Courses");

    const dateStr = new Date().toISOString().split("T")[0];
    const fileName = `Courses_${dateStr}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  // ---------------- BUILD GRID COLUMNS ----------------
  useEffect(() => {
    const data = fetchData || [];
    const visibleFields = requiredFields.filter((field) => field !== "id") || [];

    const columns: any[] = visibleFields.flatMap((field: string): any[] => {
      if (field === "academic_year_id") {
        return [{
          field,
          headerName: "Academic Year",
          editable: false,
          resizable: true,
          sortable: true,
          filter: true,
          valueGetter: (params: any) =>
            academicYearMap[params?.data?.academic_year_id] ||
            params?.data?.academic_year_id ||
            "",
        }];
      }

      if (field === "seats") {
        return [
          {
            field: "seats",
            headerName: "Seats",
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            width: 110,
          },
          {
            field: "filled_seats",
            headerName: "Filled Seats",
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            width: 130,
            valueGetter: (params: any) =>
              seatCountsMap.get(String(params?.data?.id)) || 0,
          },
          {
            field: "available_seats",
            headerName: "Available Seats",
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            width: 160,
            valueGetter: (params: any) => {
              const total = Number(params?.data?.seats ?? 0);
              const filled = seatCountsMap.get(String(params?.data?.id)) || 0;
              return Math.max(0, total - filled);
            },
            cellRenderer: (p: any) => {
              const available = Number(p.value ?? 0);
              const total = Number(p.data?.seats ?? 0);
              const isFull = available <= 0;

              return (
                <span
                  style={{
                    fontWeight: 700,
                    padding: "4px 10px",
                    borderRadius: 10,
                    background: isFull ? "#ffe5e5" : "#e8f5e9",
                    color: isFull ? "#b71c1c" : "#1b5e20",
                  }}
                >
                  {isFull ? "FULL" : `${available}/${total}`}
                </span>
              );
            },
          },
        ];
      }

      if (field === "syllabus") {
        return [{
          field,
          headerName: "Syllabus",
          editable: false,
          resizable: true,
          sortable: false,
          filter: false,
          cellRenderer: (params: any) => {
            const documentId = params.value;
            if (!documentId || documentId === "-") {
              return <span style={{ color: "#aaa", fontSize: "13px" }}>No file</span>;
            }
            return (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  params.context.handleViewPdf(documentId);
                }}
                className="btn btn-outline-primary"
                style={{
                  fontSize: "12px",
                  padding: "4px 10px",
                  borderRadius: "6px",
                  fontWeight: 600,
                }}
              >
                👁 View
              </button>
            );
          },
        }];
      }

      return [{
        field,
        headerName: field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase()),
        editable: false,
        resizable: true,
        sortable: true,
        filter: true,
        valueFormatter: (params: any) => {
          if (field.toLowerCase().includes("date") || field.toLowerCase() === "dob") {
            return formatDateStr(params.value);
          }
          return params.value;
        }
      }];
    });

    // ✅ ONLY STATUS FIELD UPDATED
    columns.push({
      field: "status",
      headerName: "Status",
      editable: false,
      resizable: true,
      sortable: true,
      filter: true,
      valueGetter: (params: any) =>
        getCourseStatus(
          params?.data?.course_start_date,
          params?.data?.course_end_date
        ),
      cellRenderer: (params: any) => {
        const status =
          params.value as "UPCOMING" | "ONGOING" | "COMPLETED" | "";

        let color = "#0d6efd";
        if (status === "ONGOING") color = "green";
        if (status === "COMPLETED") color = "red";

        return (
          <span style={{ fontWeight: 600, color }}>
            {status || "-"}
          </span>
        );
      },
      width: 130,
    });

    columns.push({
      headerName: "Action",
      field: "Action",
      cellRenderer: ActionCellRenderer,
      editable: false,
      resizable: true,
      sortable: false,
      filter: false,
      width: 120,
    } as ColumnDef);

    setColDef1(columns);
    setRowData(data);
  }, [fetchData, requiredFields, academicYearMap, seatCountsMap]);

  const defaultColDef = {
    flex: 1,
    minWidth: 120,
    editable: false,
    resizable: true,
  };

  // ---------------- UI ----------------
  return (
    <div style={{ padding: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <button
          className="btn btn-outline-success"
          onClick={handleExportExcel}
          style={{
            borderRadius: 10,
            padding: "10px 16px",
            fontSize: 16,
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontWeight: 600,
          }}
          title="Export courses to Excel"
        >
          <Download size={18} /> Export Excel
        </button>
      </div>

      <div
        className="ag-theme-alpine"
        style={{
          height: 500,
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden",
          border: "1px solid #e0e0e0",
        }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDef1}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={10}
          animateRows={true}
          context={{ handleUpdate, handleDelete, handleViewPdf }}
        />
      </div>

      {/* PDF / DOCUMENT MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "75%",
              height: "85%",
              background: "white",
              padding: "16px",
              borderRadius: "12px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <h4 style={{ margin: 0, fontWeight: 700 }}>Syllabus Document</h4>
              <div style={{ display: "flex", gap: "8px" }}>
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-secondary btn-sm"
                >
                  Open in New Tab
                </a>
                <button
                  onClick={() => setShowModal(false)}
                  className="btn btn-danger btn-sm"
                >
                  Close
                </button>
              </div>
            </div>

            <iframe
              src={pdfUrl}
              style={{ width: "100%", flex: 1, border: "1px solid #ddd", borderRadius: "8px" }}
              title="Syllabus Document Preview"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateProgram;
